/* A module that houses several js utilities for SFFP profile/enrollment pages */

AAcom.modules.loyaltyInformation = function(AAUI) {

    AAUI.isMinor = function(minor_years) {
        var dob = new Date(),
            milestone = new Date(),
            month = $j("#personalInformationForm\\.dateOfBirth\\.month").val(),
            day = $j("#personalInformationForm\\.dateOfBirth\\.day").val(),
            year = $j("#personalInformationForm\\.dateOfBirth\\.year").val(),
            minor_validation = false;
        minor_years = minor_years || 13
        if (month >= 0 && day >= 0 && year >= 0) {
            dob.setFullYear(year, month, day);
            milestone.setFullYear(milestone.getFullYear() - minor_years, milestone.getMonth(), milestone.getDate());
            minor_validation = (milestone < dob);
        }
        return minor_validation;
    };


    AAUI.getConsentRules = function() {
        var month = $j("#personalInformationForm\\.dateOfBirth\\.month").val(),
            day = $j("#personalInformationForm\\.dateOfBirth\\.day").val(),
            year = $j("#personalInformationForm\\.dateOfBirth\\.year").val(),
            countryCode = $j('#addressInformationForm\\.country').val(),
            consentRules = {
                adultAgeLimit:18,
                permissiveAdult:true,
                permissiveMinor:false,
                isMinor:false
            };

        if(month < 0 || day <= 0 || year <= 0) {
            return consentRules;
        }

        if(!countryCode) {
            AAUI.calculateMinor(consentRules, day, month, year);
            return consentRules;
        }

        $j.ajax({
            type: "GET",
            url: "/loyalty/enrollment/ajax/consentRules",
            contentType: 'application/json',
            dataType: "json",
            data: {
                "countryCode": countryCode
            },
            async : false,
            cache : false,
            timeout: 50000,
            success: function(data) {
                consentRules = data;
            },
            error: function(er) {
                consentRules.permissiveAdult = false;
            }
        });

        AAUI.calculateMinor(consentRules, day, month, year);
        return consentRules;
    };

    AAUI.calculateMinor = function(consentRules, day, month, year) {
        var dob = new Date();
        var milestone = new Date();

        dob.setFullYear(year, month, day);
        milestone.setFullYear(milestone.getFullYear() - consentRules.adultAgeLimit, milestone.getMonth(), milestone.getDate());
        consentRules.isMinor = (milestone < dob);
    };

    AAUI.addressForm = function() {
        var self = {};
        self.init = function() {
            AAUI.onChange('select[name="addressInformationForm.country"]',function() {
                var value = $j(this).val();
                $j(".js-state").hide();
                self.hideStateProvinceErrors();
                if (value == 'US' || value == 'CA') {
                    $j(".js-state[data-country=" + value + "]").css('display', 'inline-block');
                }
                $j(".js-postalCode .icon-required").hide();
                if (value == "US" || value == "CA" || value == "GB" || value == "MX") {
                    $j(".js-postalCode .icon-required").show();
                }
            });
            AAUI.onChange('input[name="addressInformationForm.addressType"]',function() {
                $j("#address-business").toggle();
            });
        };
        self.hideStateProvinceErrors = function() {
            $j("label.js-state").removeClass("is-error");
            $j("#addressInformationForm\\.usState\\.errors").hide();
            $j("#addressInformationForm\\.caState\\.errors").hide();
        }
        return self;
    }();
    AAUI.onClick('#saveButton',function() {
        var addressType = $j('input[name="addressInformationForm.addressType"]:checked').val();
        if (addressType == 'HOM') {
            $j('#addressInformationForm\\.businessName').val('');
        }
        $j("#profileInformationForm").submit();
    });
    AAUI.initEmailForm = function() {
        AAUI.onClick('#link-add-email, #link-remove-email',function() {
            $j("#profile-email").toggle();
            $j('#profile-email-add').toggle();
            if ($j(this).attr('id') == "link-remove-email") {
                $j("#profile-email").find("select,input").each(function() {
                    $j(this).val('').change();
                });
            }
        });
        AAUI.onInput('input[name="emailPhoneForm.email"]',function() {
            var $confirmEmail = $j('input[name="emailPhoneForm.confirmEmail"]');
            $confirmEmail.parents('div:first').removeClass("is-hidden");
            $confirmEmail.val('');
        });
    };
    AAUI.initPhoneForm = function() {
        AAUI.onChange('.js-phoneType',function() {
            var value = $j(this).val();
            var idx = $j(this).data('index');
            $j('#phones' + idx + '-ext').hide();
            if (value == 'BUS') {
                $j('#phones' + idx + '-ext').show();
            }
        });
        AAUI.onClick('#button-add-phone, #button-remove-phone',function() {
            var $phoneSection1 = $j("#profile-phone1"),
                $phoneSectionAdd = $j('#profile-phone-add');
            $phoneSection1.toggle();
            $phoneSectionAdd.toggle();
            if ($j(this).attr('id') === "button-add-phone") {
                AAUI.setFocusOn($phoneSection1.find(":input:first"));
            }
            if ($j(this).attr('id') == "button-remove-phone") {
                AAUI.resetFormFields($phoneSection1);
                AAUI.clearFormErrors($phoneSection1);
                AAUI.setFocusOn($phoneSectionAdd.find('#button-add-phone'));
            }
        });
    };
    AAUI.initSecurityQuestionsForm = function() {
        var maskedAnswer = "*****";
        AAUI.initQuestions = function() {
            var $options = $j('.js-securityQuestion option');
            $options.removeAttr('disabled').removeClass('is-hidden');
            $j('.js-securityQuestion').each(function() {
                var $question = $j(this);
                if ($question.val() != '-1') {
                    $options.filter('[value=' + $question.val() + ']:not(:selected)').attr('disabled', 'disabled').addClass('is-hidden');
                }
            });
        };
        AAUI.initClearAnswers = function(){
            $j('.js-securityAnswer').each(function(){
                var index = $j(this).data('index');
                var answer = $j('#securityAnswer'+index).val();
                if(answer === ''){
                    $j('#securityAnswerText' + index).removeAttr('placeholder');
                    $j('#securityAnswerText' + index).aaTextBoxMessage(' ');
                }
            });
        };
        AAUI.initPopulateAnswersWhenValidationFails = function(){
            $j('.js-securityAnswer').each(function(){
                var index = $j(this).data('index');
                var answer = $j('#securityAnswer'+index).val();
                var labelid='label#securityAnswerLabel'+index;
                $j(labelid+'.is-error '+'#securityAnswerText' + index).val(answer);
            });
        };
        AAUI.initBrowserNotSupportPlaceHolder = function(){
            var placeholderTest = document.createElement('input');
            if ( !('placeholder' in placeholderTest) ) {
                $j('.js-securityAnswer').each(function(){
                    var index = $j(this).data('index');
                    $j('#securityAnswerText' + index).aaTextBoxMessage(maskedAnswer);
                });
            }
        };
        AAUI.initQuestions();
        AAUI.initBrowserNotSupportPlaceHolder();
        AAUI.initClearAnswers();
        //AAUI.initPopulateAnswersWhenValidationFails();
        AAUI.onChange('.js-securityQuestion', function() {
            var index = $j(this).data('index');
            $j('#securityAnswer' + index).val('');
            $j('.js-securityAnswer[data-index=' + index + ']').val('');
            AAUI.initQuestions();
            AAUI.initClearAnswers();
        });
        AAUI.onFocus('.js-securityAnswer', function() {
            var index = $j(this).data('index');
            var self = $j(this);
            var targetId = '#securityAnswer' + index;
            var answerChanged = self.attr('data-changed');
            if (answerChanged) {
                self.val($j(targetId).val());
            } else {
                self.attr('placeholder',maskedAnswer);
                AAUI.initBrowserNotSupportPlaceHolder();
            }
            AAUI.initClearAnswers();
        });
        AAUI.onBlur('.js-securityAnswer', function() {
            var index = $j(this).data('index');
            var self = $j(this);
            var targetId = '#securityAnswer' + index;
            var answerChanged = self.attr('data-changed');
            if (answerChanged) {
                self.val("");
            }
            self.attr('placeholder',maskedAnswer);
            AAUI.initBrowserNotSupportPlaceHolder();
            AAUI.initClearAnswers();
        });
        AAUI.onChange('.js-securityAnswer', function() {
            var index = $j(this).data('index');
            var self = $j(this);
            var targetId = '#securityAnswer' + index;
            $j(targetId).val(self.val());
            self.attr('data-changed','true');
            self.val("");
        });
    };
    AAUI.initFocusOnErrors = function (){
        jQuery("p, a").each( (i, element) => {
            var $element = jQuery(element);
            if($element.is("[id*='globalErrorSummaryLink']") && $element.is(":visible")) {
                $j('html,body').animate({scrollTop: $element.parent().offset().top - 80});
                $element.focus();

                return false;
            }
        });
    };
    AAUI.initLoyaltyInformation = function() {
        AAUI.addressForm.init();
        AAUI.initFocusOnErrors();
        AAUI.initEmailForm();
        AAUI.initPhoneForm();
        AAUI.initSecurityQuestionsForm();
    };
};
